import { render, staticRenderFns } from "./innovation.vue?vue&type=template&id=53e728c5&scoped=true&"
import script from "./innovation.vue?vue&type=script&lang=js&"
export * from "./innovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_r7gorhlsuse2clbgb7n6qowp3u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e728c5",
  null
  
)

export default component.exports